import CoordinatorEducationApplicationListView from '@src/components/externalEducationApplication/list/CoordinatorEducationApplicationListView';
import React from 'react';

const CoordinatorEducationApplicationPage = () => <CoordinatorEducationApplicationListView />;

export default CoordinatorEducationApplicationPage;
